import React from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { enterQualifications } from "../actions/index";
import { stateProps } from "../types";
import ContainerBox from "./common/containerBox.component";
import FormSingleInput from "./form/formSingleInput.component";

const Qualifications: React.FC = () => {
  const dispatch = useDispatch();

  const qualification = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.qualifications
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterQualifications(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"08"} title={"What are your qualifications?"} />
        <FormSingleInput
          value={qualification}
          onInputChange={onInputChange}
          placeholder={"Your qualifications"}
          subTitle={"Please separate your qualifications with a comma"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Qualifications;
